module.exports = __webpack_public_path__ + "media/images/icons/flag-ae1f19485cdc7567861f9900915674ee.svg";